import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Card "em andamento" das listas (Folha, Múltiplos, Benefícios): rótulo laranja
 * com ponto de status, título de 20px, até 3 métricas e "Abrir … →". O card
 * inteiro é o link.
 */
export const CardDestaque = ({
  rotulo,
  titulo,
  metricas,
  acao,
  to,
  corStatus = "hsl(var(--primary))",
  children,
  className,
}: {
  rotulo: ReactNode;
  titulo: ReactNode;
  metricas: { rotulo: ReactNode; valor: ReactNode; tom?: "alerta" }[];
  /** Texto do link, ex.: "Abrir folha". */
  acao: ReactNode;
  to: string;
  corStatus?: string;
  /** Conteúdo extra abaixo das métricas (ex.: barra de parcelas). */
  children?: ReactNode;
  className?: string;
}) => (
  <Link
    to={to}
    className={cn(
      "group flex flex-col gap-4 rounded-xl border border-primary/35 bg-card p-5 transition-colors hover:border-primary/70 sm:p-6",
      className,
    )}
  >
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="flex flex-col gap-1.5">
        <span className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.08em] text-primary-text">
          <span className="h-[7px] w-[7px] rounded-full" style={{ background: corStatus }} />
          {rotulo}
        </span>
        <span className="text-xl font-semibold tracking-titulo">{titulo}</span>
      </div>
      <span className="flex items-center gap-1.5 text-sm font-medium text-primary-text group-hover:underline group-hover:underline-offset-4">
        {acao}
        <ArrowRight className="h-4 w-4" />
      </span>
    </div>
    <div className="grid gap-4 tabular-nums" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))" }}>
      {metricas.map((m, i) => (
        <div key={i} className="flex flex-col gap-0.5">
          <span className="text-xs text-muted-foreground">{m.rotulo}</span>
          <span className={cn("text-lg font-semibold", m.tom === "alerta" && "text-amber-700 dark:text-amber-400")}>
            {m.valor}
          </span>
        </div>
      ))}
    </div>
    {children}
  </Link>
);
